Fastweb.Admin.Articles = (function($) {

  init = function() {
    $("select[data-behavior=article-channel]").change(function() {
      var url = window.location.origin;
      $.get({
        url: url + '/admin/articles/article_categories',
        dataType: 'json',
        data: {channel_id: $(this).val()}
      }).done(function(data) {
        var html = '';
        data.forEach(function(element) {
          html = html + '<option value="' + element.id + '">' + element.name + '</option>';
        });
        $('#article_categories').html(html);
      });

    });
  }

  initEditFooterRail = function() {
    var addArticle;

    $('.sortable').sortable();

    // Add article to popularity rankings
    $('#add_article').click(function() {
      if(addArticle != undefined) {
        $('.sortable').append('<tr class="ui-sortable-handle">' +
            '<input type="hidden" name="article_ids[]" id="article_id" value="' + addArticle.id + '">' +
            '<td class="hover-grab"></td>' +
            '<td class="hover-grab">' + addArticle.name +
            '</td>' +
            '<td class="hover-grab">' + addArticle.status +
            '</td>' +
            '<td>' +
            '<a target="_blank" href="http://www.fastweb.com/' + addArticle.path + '">View</a>' +
            ' | ' +
            '<a class="remove" href="javascript:void(0);" onclick="$(this).closest(\'tr\').remove();">Remove</a>' +
            ' | ' +
            '<a href="/admin/articles/' + addArticle.slug + '/edit">Edit</a>' +
            '</td>' +
          '</tr>'
        );

        addArticle = undefined;
      }

      $('#search').val('');

    });

    // Remove article from popularity rankings
    $('.remove').click(function() {
      $(this).closest('tr').remove();
    });

    // Article search autocomplete
    $('#search').autocomplete({
      source: function(request, response) {
        url = window.location.origin + '/admin/articles/search';
        text = $('#search').val();
        channel_id = $('#channel_id').val() || '';
        $.ajax({
          url: url,
          dataType: "json",
          data: {q: text, channel_id: channel_id},
          method: 'GET',
          cache: false
        })
        .done(function(data, textStatus, jqXHR) {
          var results = $.map(data, function( item ) {
              return { label: item.name, status: item.status, value: item.id, slug: item.slug, path: item.path };
            });

          response(results);
        })
        .fail(function(jqHXR, textStatus, errorThrown) {
          console.log("Failed to retrieve autocomplete results - " + errorThrown);
        });
      },
      classes: {
        "ui-autocomplete": "white-bg",
      },
      minLength: 2,
      delay: 0,
      select: function(event, ui) {
        addArticle = {id: ui.item.value, name: ui.item.label, status: ui.item.status, slug: ui.item.slug, path: ui.item.path}
        event.preventDefault();
      },
      focus: function(event, ui) {
        event.preventDefault();
        $('#search').val(ui.item.label);
      }
    });
  }

  fetchSlugValFromArticleTitle = function() {
    $('#article-title').blur(function(){
      var articleTitle = $(this).val();
      articleTitle = articleTitle.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
      $('#article-slug').val(articleTitle);
    })
  }

  setCharacterLimit = function(text, charCount) {
    $(text).on('keyup', function() {
      const length = $(this).val().length;
      $(charCount).html(length);
    });
  }

  return {
    init: init,
    initEditFooterRail: initEditFooterRail,
    fetchSlugValFromArticleTitle: fetchSlugValFromArticleTitle,
    setCharacterLimit: setCharacterLimit
  }

})(jQuery);
